export const parseCookies = (): string =>
  document.cookie
    .split(';')
    .find(t => t.indexOf('session=') !== -1)
    ?.replace('session=', '') || '';
